@if (!listView) {
  <div class="container">
    @if (loading) {
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    }
    @if (!loading && !error  && propertyRecord) {
      <mat-list>
        <mat-list-item style="padding: 0" class="address">
          @if (propertyRecord.Proh_PropertyName) {
            <div mat-line>{{ propertyRecord.Proh_PropertyName }}</div>
          }
          @if (propertyRecord.Proh_Address1) {
            <div mat-line>{{ propertyRecord.Proh_Address1 }}</div>
          }
          @if (propertyRecord.Proh_Address2) {
            <div mat-line>{{ propertyRecord.Proh_Address2 }}</div>
          }
          @if (propertyRecord.Proh_Address3) {
            <div mat-line>{{ propertyRecord.Proh_Address3 }}</div>
          }
          @if (propertyRecord.Proh_Address4) {
            <div mat-line>{{ propertyRecord.Proh_Address4 }}</div>
          }
          <div mat-line>{{ propertyRecord.Proh_PostCode }}</div>
        </mat-list-item>
      </mat-list>
    }
    @if (!loading && error) {
      <mat-icon fontIcon="fa-unlink" fontSet="fas"></mat-icon>
      Unable to connect to URM
    }
  </div>
}

@if (listView) {
  @if (loading) {
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  }
  @if (!loading && !error && propertyRecord) {
    <mat-list>
      <mat-list-item style="padding: 0" class="address">
        @if (propertyRecord.Proh_PropertyName) {
          <div mat-line>{{ propertyRecord.Proh_PropertyName }}</div>
        }
        @if (propertyRecord.Proh_Address1) {
          <div mat-line>{{ propertyRecord.Proh_Address1 }}</div>
        }
        @if (propertyRecord.Proh_Address2) {
          <div mat-line>{{ propertyRecord.Proh_Address2 }}</div>
        }
        @if (propertyRecord.Proh_Address3) {
          <div mat-line>{{ propertyRecord.Proh_Address3 }}</div>
        }
        @if (propertyRecord.Proh_Address4) {
          <div mat-line>{{ propertyRecord.Proh_Address4 }}</div>
        }
        <div mat-line>{{ propertyRecord.Proh_PostCode }}</div>
      </mat-list-item>
    </mat-list>
<!--    <urm-caution-widget [externalPropertyReference]="externalPropertyReference"-->
<!--    mode="verbose"></urm-caution-widget>-->
  }
  @if (!loading && error) {
    <mat-icon fontIcon="fa-unlink" fontSet="fas"></mat-icon>
    Unable to obtain property details from Core
  }
}


